// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ImageSlider_arrow__hqDvG","prev":"ImageSlider_prev__2JNGm","next":"ImageSlider_next__3UT6C","img":"ImageSlider_img__3X8mo"};